import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import Select from 'react-select-v3';
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg';
import { openOrCreateChat } from 'redux/modules/job-detail/effects';
import { MenuList } from 'utils/select';
import { driverConversationSelectStyles } from './styles';

const t = {
  placeholder: 'Create new conversation',
};

const Placeholder = styled(({ className }) => (
  <div className={className}>
    <MessageIcon />
    <span className="text">{t.placeholder}</span>
  </div>
))`
  display: flex;

  .text {
    margin-left: 8px;
  }
`;

const DriverConversationSelect = ({ driverId, isDispatchee, className }) => {
  const [created, setCreated] = useState(false);
  const dispatch = useDispatch();

  const handleSelectOption = (option) => {
    const [{ value }] = option;
    dispatch(openOrCreateChat({ type: value, driverId }));
    setCreated(true);
  };

  const options = [
    { label: 'About and offer', value: 'offer' },
    { label: 'Jobs planning', value: 'planning' },
    { label: 'Account management', value: 'management' },
    { label: 'Billing', value: 'billing' },
    { label: 'Legal documentation', value: 'legal' },
    { label: 'Other issues', value: 'other' },
  ];

  const dispatcheeOptions = options.filter(({ value }) => ['other'].includes(value));

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={className}
    >
      <Select
        inputId={`select_typeOf_conversation-${driverId}`}
        name="select_typeOf_conversation"
        isDisabled={created}
        value={null}
        closeMenuOnSelect
        isMulti
        options={isDispatchee ? dispatcheeOptions : options}
        onChange={handleSelectOption}
        styles={driverConversationSelectStyles}
        components={{ MenuList }}
        placeholder={<Placeholder />}
        isClearable={false}
      />
    </div>
  );
};

export default DriverConversationSelect;
